/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 2/11/2023
 */

import { Button, ButtonGroup } from "@mui/material";

const Counter = ({ value, onIncrement, onDecrement, size = "small", className, disableIncrement }) => {
  return (
    <ButtonGroup className={className} size={size}>
      <Button onClick={onDecrement}>-</Button>
      <Button disableFocusRipple disableRipple disableTouchRipple disableElevation>{value}</Button>
      <Button onClick={onIncrement} disabled={disableIncrement}>+</Button>
    </ButtonGroup>
  );
}

export default Counter;